import { render, staticRenderFns } from "./ListBlock.vue?vue&type=template&id=318a9224"
import script from "./listBlock.ts?vue&type=script&lang=js&external"
export * from "./listBlock.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports